import { useCallback, useEffect, useRef } from 'react'

/*
 * Nur die juengste Anfrage zaehlt.
 *
 * Seit die Listen ohne Knopfdruck filtern, koennen zwei Abfragen gleichzeitig
 * unterwegs sein — die zweite ueberholt die erste regelmaessig, und dann steht
 * in der Tabelle das Ergebnis des vorletzten Filters. Ausserdem darf eine
 * Antwort, die nach dem Verlassen der Seite eintrifft, nichts mehr setzen.
 *
 *   const latest = useLatestOnly()
 *   const laden = () => {
 *       const istAktuell = latest()
 *       http.get(…).then(({ data }) => {
 *           if (!istAktuell()) return
 *           …
 *       })
 *   }
 */
export default function useLatestOnly() {
	const current = useRef(0)
	const mounted = useRef(true)

	useEffect(() => () => (mounted.current = false), [])

	return useCallback(() => {
		const request = ++current.current
		return () => mounted.current && request === current.current
	}, [])
}
